import React from 'react';
import moment from 'moment';
import SubscriptionNoticeWrapper from '@src/Routes/Notice/SubscriptionNoticeWrapper';
import { useCustomerForTrialsQuery } from '@src/graphql/generated';

export default function TrialActiveNotice() {
  const { loading, error, data } = useCustomerForTrialsQuery();

  if (loading || error) {
    return null;
  }

  const diffInDays = moment(data.customer.planInfo.trialEndsAt).diff(moment(), 'days');

  return (
    <SubscriptionNoticeWrapper
      status={diffInDays === 0 ? 'Trial ends today.' : `${diffInDays + 1} days trial remaining.`}
      text={'Subscribe and keep the access.'}
    />
  );
}
